export default __webpack_public_path__ + "static/media/familia.6deb495f.png";